import TrafficLight from "./traffic-light.jsx";

export default TrafficLight;